import * as React from 'react';
import { styled } from '@mui/material/styles';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';


// 可滚动Tabs
export default function ScrollTabs({
    data,
    activeIndex,
    onClick
}: {
    data: StyledTabProps[],
    activeIndex: number,
    onClick: (index: number) => void,
}) {
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        onClick(newValue);
    };

    return (
        <StyledTabs
            value={activeIndex}
            onChange={handleChange}
        >
            {
                data.map((item, index) => (
                    <StyledTab key={index} title={item.title} />
                ))
            }
        </StyledTabs>
    );
}

// 自定义 Tabs 容器：与设计稿「当前营业状态-子功能」一致，标签间距 24px
const StyledTabs = styled((props: StyledTabsProps) => (
    <Tabs
        variant='scrollable'
        scrollButtons='auto'
        {...props}
    />
))({
    minHeight: 56,
    height: 56,
    '& .MuiTabs-flexContainer': {
        gap: 24,
    },
    '& .MuiTabs-indicator': {
        display: 'none',
    },
});

// 自定义 Tab：选中态为主题色底+白字、未选中态为辅助色-500 文字，无阴影，与 Figma 设计稿一致
const StyledTab = styled((props: StyledTabProps) => (
    <Tab {...props} label={props.title} />
))(({ theme }) => ({
    minHeight: 56,
    height: 56,
    borderRadius: 8,
    fontSize: 20,
    lineHeight: '24px',
    fontStyle: 'normal',
    fontWeight: 500,
    padding: '16px 8px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    display: 'inline-block',
    // 未选中：设计稿 图标-按钮/辅助色-500 (#525b86)，使用主题 token
    color: 'var(--text-neutral-500)',
    '&.Mui-selected': {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        // 设计稿选中态无阴影
        boxShadow: 'none',
    },
}));

// types
interface StyledTabsProps {
    children?: React.ReactNode;
    value: number;
    onChange: (event: React.SyntheticEvent, newValue: number) => void;
}

interface StyledTabProps {
    title: string;
}